export default {
    state: {
        isOpen: false,
        genre: null,
        video_provider: null,
        country: null,
        year: null,
        rating: null
    },
    actions: {},

    mutations: {
        setOpenFilter(state, content) {
            state.isOpen = content;
        }
    },

    getters: {
        getFilter(state) {
            return state;
        }
    }
};
